import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Font
} from '@react-pdf/renderer';
import { dateFormatter, getCurrentDateTime } from '../../../../../utils';

Font.register({
  family: 'Roboto',
  fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'medium' }]
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const styles = StyleSheet.create({
  page: {
    padding: 20,
    paddingTop: '10%',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  text: {
    fontSize: 10
  },
  textUnderlined: {
    fontSize: 10,
    textDecoration: 'underline',
    textDecorationColor: 'black',
    textDecorationThickness: 1.5,
    marginBottom: 2,
    width: '120%'
  },
  heading: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 20,
    textAlign: 'center'
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    gap: 20,
    marginTop: 20,
    borderBottom: '1px solid black'
  },
  contentContainer3: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    gap: 20,
    borderTop: '1px solid black'
  },
  column: {
    width: '33%',
    display: 'flex',
    flexDirection: 'column',
    gap: 5
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 5
  },
  label: {
    fontWeight: 'bold',
    fontSize: 10
  },
  value: {
    fontSize: 10,
    fontWeight: 'normal',
    width: '65%'
  }
});

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const PatientRegistrationPdf2 = ({ data }) => {
  console.log('HELLO REG NO,', data);

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const ageString = data.age;
  const years = ageString.match(/\d+Y/);

  function convertTo12HourFormat(time24) {
    let [hours, minutes] = time24.split(':').map(Number);
    const period = hours < 12 ? 'AM' : 'PM';
    hours = hours % 12 || 12;
    return `${hours}:${minutes.toString().padStart(2, '0')} ${period}`;
  }

  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title={`${data.name} Registration`}>
          <Page size="A4" style={styles.page}>
            <View
              style={{
                fontFamily: 'Roboto',
                fontSize: '20px'
              }}
            >
              <Text content={'Op Slip'} />
            </View>
            <View>
              <View
                style={{
                  ...styles.row,
                  fontFamily: 'Roboto',
                  position: 'relative',
                  top: '115%',
                  left: '20%'
                }}
              >
                <Text content={'Follow up :- .........................................'} />
              </View>
            </View>
            <View style={styles.contentContainer}>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text content="UHID NO.     :- " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                  <Text
                    content={data.uhid}
                    style={{ ...styles.value, borderBottom: '1px solid black', textAlign: 'start' }}
                  />
                </View>
                <View style={styles.row}>
                  <Text content="Name  : " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                  <Text
                    content={data.name}
                    style={{ ...styles.value, borderBottom: '1px solid black', textAlign: 'start' }}
                  />
                </View>
                <View style={styles.row}>
                  <Text content="Guardian      : " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                  <Text content={''} style={{ ...styles.value, borderBottom: '1px solid black', textAlign: 'start' }} />
                </View>
                <View style={styles.row}>
                  <Text content="Department    : " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                  <Text
                    content={data.department}
                    style={{ ...styles.value, borderBottom: '1px solid black', textAlign: 'start' }}
                  />
                </View>
                <View style={styles.row}>
                  <Text content="Pay Type      : " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                  <Text
                    content={data.pay_type}
                    style={{ ...styles.value, borderBottom: '1px solid black', textAlign: 'start' }}
                  />
                </View>
                <View style={styles.row}>
                  <Text content="Token No.     : " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                  <Text
                    content={data.token_no}
                    style={{ ...styles.value, borderBottom: '1px solid black', textAlign: 'start' }}
                  />
                </View>
              </View>

              <View style={styles.column}>
                <View style={styles.row}>
                  <Text content="OP No.        : " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                  <Text
                    content={`${data.op_no}`}
                    style={{ ...styles.value, borderBottom: '1px solid black', textAlign: 'start' }}
                  />
                </View>
                <View style={styles.row}>
                  <Text content="Age/Sex       : " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                  <Text
                    content={`${years} / ${data.gender}`}
                    style={{ ...styles.value, borderBottom: '1px solid black', textAlign: 'start' }}
                  />
                </View>
                <View style={styles.row}>
                  <Text content="Address       : " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                  <Text
                    content={data.address}
                    style={{ ...styles.value, borderBottom: '1px solid black', textAlign: 'start' }}
                  />
                </View>
                <View style={styles.row}>
                  <Text content="Consultant    : " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                  <Text
                    content={data.consultant}
                    style={{ ...styles.value, borderBottom: '1px solid black', textAlign: 'start' }}
                  />
                </View>
                <View style={styles.row}>
                  <Text content="Mobile No.    : " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                  <Text
                    content={data.mobile}
                    style={{ ...styles.value, borderBottom: '1px solid black', textAlign: 'start' }}
                  />
                </View>
              </View>

              <View style={styles.column}>
                <View style={styles.row}>
                  <Text content="OP Date       : " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                  <Text
                    content={formatDate(data?.reg_date)}
                    style={{ ...styles.value, borderBottom: '1px solid black', textAlign: 'start' }}
                  />
                </View>
                <View style={styles.row}>
                  <Text content="Patient Type  : " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                  <Text
                    content={data.opd_type}
                    style={{ ...styles.value, borderBottom: '1px solid black', textAlign: 'start' }}
                  />
                </View>
                <View style={styles.row}>
                  <Text content="Empanelment : " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                  <Text
                    content={data.empanelment}
                    style={{ ...styles.value, borderBottom: '1px solid black', textAlign: 'start' }}
                  />
                </View>
                <View style={styles.row}>
                  <Text content="Doctor Room  : " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                  <Text
                    content={data.doctor_room}
                    style={{ ...styles.value, borderBottom: '1px solid black', textAlign: 'start' }}
                  />
                </View>
              </View>
            </View>
            <View
              style={{
                ...styles,
                width: '100%'
              }}
            >
              <View style={{ ...styles.column, border: '1px solid black', gap: 6, padding: '6px' }}>
                <View style={styles.row}>
                  <Text
                    content="Facilities"
                    style={{ fontSize: 10, textDecoration: 'underline', fontFamily: 'Roboto' }}
                  />
                </View>

                <View style={styles.row}>
                  <Text content="*E.C.G/X-Ray" style={{ fontSize: 10 }} />
                </View>
                <View style={styles.row}>
                  <Text content="*Physiotheraphy" style={{ fontSize: 10 }} />
                </View>
                <View style={styles.row}>
                  <Text content="*Echocardiography" style={{ fontSize: 10 }} />
                </View>
                <View style={styles.row}>
                  <Text content="*Fully Automated Laboratory" style={{ fontSize: 10 }} />
                </View>
                <View style={styles}>
                  <Text content="*Health Plans" style={{ fontSize: 10, marginBottom: 4 }} />
                  <Text content="-individual" style={{ fontSize: 10, marginBottom: 4 }} />
                  <Text content="-corporate" style={{ fontSize: 10 }} />
                </View>
                <View style={styles.row}>
                  <Text content="*24 Hours Pharmacy" style={{ fontSize: 10 }} />
                </View>
                <View style={styles.row}>
                  <Text
                    content="Insurance & TPA"
                    style={{ fontSize: 10, textDecoration: 'underline', fontFamily: 'Roboto' }}
                  />
                </View>
                <View style={styles.row}>
                  <Text content="*Covered For all Insurance Companies & Tpa" style={{ fontSize: 10 }} />
                </View>
                <View style={styles.row}>
                  <Text content="*ECHS Approved" style={{ fontSize: 10 }} />
                </View>
                <View style={styles.row}>
                  <Text content="*Govt. Approved De-Addiction Center" style={{ fontSize: 10 }} />
                </View>
                <View style={styles.row}>
                  <Text
                    content="Emergency & Ambulance -24 Hours"
                    style={{ fontSize: 10, textDecoration: 'underline', fontFamily: 'Roboto' }}
                  />
                </View>
                <View style={styles}>
                  <Text content="8054922351" style={{ fontSize: 10, marginBottom: 4 }} />
                  <Text content="8054922340" style={{ fontSize: 10, marginBottom: 4 }} />
                  <Text content="8054922386" style={{ fontSize: 10 }} />
                </View>
              </View>
            </View>
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};

{
  /* <View
                  style={{
                    ...styles.contentContainer2,
                    zIndex: 5,
                    marginLeft: 0,
                    paddingLeft: 0,
                    marginRight: 50,
                    position: 'relative',
                    top: '-3%'
                  }}
                >
                  <View style={{ ...styles.column, border: '1px solid black', gap: 6, padding: '6px' }}>
                    <View style={styles.row}>
                      <Text
                        content="INVESTIGATION"
                        style={{ fontSize: 10, textDecoration: 'underline', fontFamily: 'Roboto' }}
                      />
                    </View>
                    <View style={styles.row}>
                      <Text content="HB/TLC/DLC" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="CBC" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="ESR" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="Blood Sugar F/PP/R" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="HbA1C" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="Blood Urea" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="S. Creatinine" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="S. Uric Acid" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="S. Bilirubin (T / D)" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="S.G.O.T/S.G.P.T." style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="LFT" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="KFT" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="RA Factor" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="CRP" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="Vitamin B12/Vit.D" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="Lipid Profile" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="Blood Group" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="Urine R/M" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="T3, T4, TSH" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="Viral / Makers " style={{ fontSize: 10 }} />
                      <Text content="(Hep-B / Hep-C / HIV)" style={{ fontSize: 7 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="X-Ray" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="USG Abdomen" style={{ fontSize: 10 }} />
                      <Text content="(Upper / Lower / Whole)" style={{ fontSize: 7 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="BT/CT" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="VDRL" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="PT/INR" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="PSA" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="Typhidot (IGG / IGM)" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="Dengue Serology" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="Malaria Parasite Antigen" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="AEC" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="CT-Scan" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="Echo" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="ECG" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="MRI" style={{ fontSize: 10 }} />
                      <Text content="(Screening / Lumber / Cervical)" style={{ fontSize: 7 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="Mantoux Test" style={{ fontSize: 10 }} />
                    </View>
                    <View style={styles.row}>
                      <Text content="Sputum AFB" style={{ fontSize: 10 }} />
                    </View>
                  </View>
                </View> */
}
